import '../confirmBox/confirm.css';
import { React, Locale, useEffect, useState } from '../../libraries';
import { Modal, Button,Form } from 'react-bootstrap';

const BookingCancelConfirmModal = ({
  isComplte,
  reason,
  showModal,
  handleClose,
  deleteServices,
  deleteItemId,
  cancelBookingMessage,
  setIsCancelBehalfOnCustomer,
  isCancelBehalfOnCustomer
}) => {
  const { t } = Locale();
  const [isError, setIsError] = useState(true);
  const [updateCancelReason, setUpdateCancelReason] = useState('');
  const isCustomer = localStorage.getItem('role')?.toLowerCase() === 'customer';

  useEffect(() => {
    setIsError(!isComplte);
  }, [isComplte]);

  const handleInputChange = (e) => {
    const value = e.target.value.trim();
    setUpdateCancelReason(value);
    setIsError(!value);
  };

  const handleCheckboxChange = (e) => {
    setIsCancelBehalfOnCustomer(e.target.checked);
  };

  const shouldShowCancelMessage =
    (isCustomer && cancelBookingMessage) ||
    (isCancelBehalfOnCustomer && !isCustomer && cancelBookingMessage);

  const renderConfirmationMessage = () =>
    shouldShowCancelMessage ? (
      <div className="cancel-message-outer">
        <div className="d-flex gap-2">
          <i className="bi bi-exclamation-triangle-fill"></i>
          <div>{cancelBookingMessage}</div>
        </div>
      </div>
    ) : null;

  const handleConfirm = () => {
    deleteServices(deleteItemId, updateCancelReason);
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      dialogClassName="custom-modal customModal"
    >
      <Modal.Header closeButton className="headerLine" />
      <Modal.Body>
        <div className="text-center">
          <p className="delete-pop-up-message">
            {t('teamSetupField.areYouSureYouWantTo')}
            <br />
            {t('userBooking.areYouSure')}
          </p>

          <div className="form-floating mb-3">
            <textarea
              name="cancel_reason"
              className="form-control height100px"
              id="floatingTextArea"
              onChange={handleInputChange}
              value={updateCancelReason || reason}
            />
            <label htmlFor="floatingTextArea">
              {t('signMessage.commentHere')}
              <span className="gl-form-asterisk">
                <span className="small-err">*</span>
              </span>
            </label>
          </div>
          {!isCustomer && (
            <div className="text-start mb-3">
              <Form.Check
                type="checkbox"
                id="cancel-behalf"
                label={t('userBooking.cancelOnBehalf')}
                checked={isCancelBehalfOnCustomer}
                onChange={handleCheckboxChange}
              />
            </div>
          )}
          {renderConfirmationMessage()}
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center footerLine">
        <Button className="btn btn-light cancelbutton" onClick={handleClose}>
          {t('button.no')}
        </Button>
        <Button
          className="btn btn-light deletebutton"
          disabled={isError}
          onClick={handleConfirm}
        >
          {t('button.yes')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BookingCancelConfirmModal;